import React from "react";
import { SliderBase, CentralizedSliderBase } from "@reusejs/react";
import { AlliancesList, CollaborationList } from "services";
import LeftArrowSvg from "../../Icons/LeftArrowSvg";
import RightArrowSvg from "../../Icons/RightArrowSvg";
import "../../../../node_modules/@reusejs/react/dist/vendors/swiper.css";
import { ImageSliderComponent } from "../propertiesPage/ImageSliderComponent";
import { AlliancesSliderComponent } from "../propertiesPage/AlliancesSliderComponent";
const AllianceComponent = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center m-auto max-w-7xl p-4 lg:p-8">
      <h1 className="md:text-3xl text-xl font-extrabold text-gray-900">
        Our Alliances
      </h1>
      <p className="md:text-lg text-sm font-normal text-gray-500 lg:w-1/2 text-center mt-4 mb-6">
        We are closely associated with various Banks, Financial Institutions,
        ARCs, Liquidators, Insolvency professionals to complete and accelerate
        the entire auction process.
      </p>
      <AlliancesSliderComponent elements={AlliancesList} slide={true} />
      <div className="flex flex-col w-full justify-center items-center my-20 border-t-2 alliancesSection">
        <h1 className="md:text-3xl text-xl font-extrabold text-gray-900 my-10">
          Our Collaborations
        </h1>
        <AlliancesSliderComponent elements={CollaborationList} slide={false} />
      </div>
    </div>
  );
};

export default AllianceComponent;
